// Hideo - Italian translations: SEO, published videos and Shorts (seo, published, shorts).
// Keys are the English source strings used in the code (see docs/i18n.md).
import type { Dictionary } from '../types'

const it: Dictionary = {
    // features/seo.ts: checks
    'Main: "{kw}"': 'Principale: "{kw}"',
    'Keyword': 'Parola chiave',
    'Choose the main keyword: it is what people type in the search.': 'Scegli la parola chiave principale: è quello che la gente scrive nella ricerca.',
    'Title': 'Titolo',
    'The title is missing.': 'Manca il titolo.',
    'Too long ({n}/100).': 'Troppo lungo ({n}/100).',
    'Choose the keyword first.': 'Prima scegli la parola chiave.',
    'Put the keyword in the title.': 'Metti la parola chiave nel titolo.',
    'Move the keyword to the start of the title.': "Sposta la parola chiave all'inizio del titolo.",
    'Fine, but on a phone only about 60 characters show (now {n}).': 'Va bene, ma da telefono si vedono circa 60 caratteri (ora {n}).',
    'Keyword at the start, right length.': "Parola chiave all'inizio, lunghezza giusta.",
    'Description': 'Descrizione',
    'Write the description.': 'Scrivi la descrizione.',
    'A bit short ({n} characters): aim for at least 150.': "Un po' corta ({n} caratteri): punta ad almeno 150.",
    'Put the keyword in the first lines (the first ~150 letters show in search).': 'Metti la parola chiave nelle prime righe (le prime ~150 lettere si vedono nella ricerca).',
    'Keyword in the first lines.': 'Parola chiave nelle prime righe.',
    'No chapters: you can generate them from the script.': 'Nessun capitolo: puoi generarli dallo script.',
    'Each line must start with a time, e.g. "1:24 The castle".': 'Ogni riga deve iniziare con un orario, es. "1:24 Il castello".',
    'The first chapter must start at 0:00.': 'Il primo capitolo deve partire da 0:00.',
    'You need at least 3 chapters.': 'Servono almeno 3 capitoli.',
    'Each chapter must last at least 10 seconds.': 'Ogni capitolo deve durare almeno 10 secondi.',
    'Chapters': 'Capitoli',
    '{n} chapters ready.': '{n} capitoli pronti.',
    'Tags': 'Tag',
    'Add a few tags (they count for little, but help with typos).': 'Aggiungi qualche tag (pesano poco, ma aiutano con gli errori di battitura).',
    'Too many characters ({n}/500).': 'Troppi caratteri ({n}/500).',
    '{n} tag · {len}/500 characters.': '{n} tag · {len}/500 caratteri.',
    '{n} tags · {len}/500 characters.': '{n} tag · {len}/500 caratteri.',
    'Hashtags': 'Hashtag',
    'Add 1–3 hashtags: the first 3 appear above the title.': 'Aggiungi 1–3 hashtag: i primi 3 compaiono sopra il titolo.',
    'There are {n}: above 15, YouTube ignores them all.': 'Sono {n}: oltre 15 YouTube li ignora tutti.',
    '{n} hashtags: only the first 3 show above the title.': '{n} hashtag: sopra il titolo si vedono solo i primi 3.',
    '{n} hashtag.': '{n} hashtag.',
    '{n} hashtags.': '{n} hashtag.',
    'Thumbnail image': 'Miniatura',
    'Thumbnail uploaded.': 'Miniatura caricata.',
    'Upload a thumbnail in the Details tab: it is the first thing people see.': 'Carica una miniatura nella scheda Dettagli: è la prima cosa che si vede.',
    'Opening hook': 'Gancio',
    'Write the script: the first sentence is the hook of the first seconds.': 'Scrivi lo script: la prima frase è il gancio dei primi secondi.',
    'The first sentence has {n} words (~{sec} s): shorten it, the hook must land in the first 2–3 seconds.': 'La prima frase ha {n} parole (~{sec} s): accorciala, il gancio deve arrivare nei primi 2–3 secondi.',
    'First sentence of {n} word (~{sec} s): it lands right away.': 'Prima frase di {n} parole (~{sec} s): arriva subito.',
    'First sentence of {n} words (~{sec} s): it lands right away.': 'Prima frase di {n} parole (~{sec} s): arriva subito.',
    'Duration': 'Durata',
    "Without a script I can't estimate the duration.": 'Senza script non posso stimare la durata.',
    'About {time}: a Short works better under 60–90 seconds.': 'Circa {time}: per uno Short sotto i 60–90 secondi rende di più.',
    'The script is almost empty.': 'Lo script è quasi vuoto.',
    'About {time} of speech.': 'Circa {time} di parlato.',
    'On Shorts only about {max} characters show (now {n}): shorten it.': 'Sugli Short se ne vedono circa {max} caratteri (ora {n}): accorcialo.',
    'Short, it all shows.': 'Breve, si legge tutto.',
    'Choose the keyword: on TikTok and Instagram people search by typing too.': 'Scegli la parola chiave: anche su TikTok e Instagram la gente cerca scrivendo.',
    'Caption': 'Didascalia',
    'Write the caption (the same for Shorts, TikTok and Instagram).': 'Scrivi la didascalia (la stessa per Shorts, TikTok e Instagram).',
    'Too long for Instagram ({n}/2200).': 'Troppo lunga per Instagram ({n}/2200).',
    'Put the keyword in the first lines: about {max} characters show before "more".': 'Metti la parola chiave nelle prime righe: prima di "altro" se ne vedono circa {max} caratteri.',
    'Ready to copy.': 'Pronta da copiare.',
    'Cover': 'Copertina',
    'Cover uploaded.': 'Copertina caricata.',
    'Upload a vertical cover in Details: it is what shows in the profile grid.': 'Carica una copertina verticale nei Dettagli: è quella che si vede nella griglia del profilo.',
    'Image uploaded.': 'Immagine caricata.',
    'Upload the post image (or the first slide) in Details.': "Carica l'immagine del post (o la prima slide) nei Dettagli.",
    'First line': 'Prima riga',
    'The first line of the caption is the hook: keep it short and strong.': 'La prima riga della didascalia è il gancio: scrivila corta e forte.',
    'The first line is long ({n} characters): about {max} show before "more".': 'La prima riga è lunga ({n} caratteri): prima di "altro" se ne vedono circa {max}.',
    'It all shows before "more".': 'Si legge tutta prima di "altro".',
    'Choose the keyword: Instagram search reads the caption.': 'Scegli la parola chiave: la ricerca di Instagram legge la didascalia.',
    'Write the caption.': 'Scrivi la didascalia.',
    'Too long ({n}/2200).': 'Troppo lunga ({n}/2200).',
    'Put the keyword in the first line.': 'Metti la parola chiave nella prima riga.',
    'Choose the keyword: it is what people type on Google.': 'Scegli la parola chiave: è quello che la gente scrive su Google.',
    'Title for Google': 'Titolo per Google',
    'Google shows about {max} characters (now {n}).': 'Google ne mostra circa {max} caratteri (ora {n}).',
    'Right length, with the keyword.': 'Lunghezza giusta, con la parola chiave.',
    'Meta description': 'Meta descrizione',
    'Write the description that appears under the title on Google.': 'Scrivi la descrizione che compare sotto il titolo su Google.',
    'A bit short ({n}): aim for {min}–{max} characters.': "Un po' corta ({n}): punta a {min}–{max} caratteri.",
    'Too long ({n}/{max}): Google cuts it.': 'Troppo lunga ({n}/{max}): Google la taglia.',
    'Put the keyword in the description.': 'Metti la parola chiave nella descrizione.',
    'Looks good.': 'Va bene.',
    'Address': 'Indirizzo',
    'Choose the page address (you can generate it from the title).': "Scegli l'indirizzo della pagina (puoi generarlo dal titolo).",
    'Shorten it: short addresses work better.': 'Accorcialo: gli indirizzi brevi funzionano meglio.',
    'Put the keyword in the address.': "Metti la parola chiave nell'indirizzo.",
    'Short and clear.': 'Breve e chiaro.',
    'Introduction': 'Introduzione',
    'Write the article in Details.': "Scrivi l'articolo nei Dettagli.",
    'Put the keyword in the first 100 words.': 'Metti la parola chiave nelle prime 100 parole.',
    'Structure': 'Struttura',
    '{n} subheadings.': '{n} sottotitoli.',
    'Split the article with at least 2 subheadings (Heading 2 or 3).': "Dividi l'articolo con almeno 2 sottotitoli (Titolo 2 o 3).",
    'Length': 'Lunghezza',
    'The article is empty.': "L'articolo è vuoto.",
    '{n} words · {min} min read (for Google, at least {least} is better).': '{n} parole · {min} min di lettura (per Google meglio almeno {least}).',
    '{n} words · {min} min read.': '{n} parole · {min} min di lettura.',
    'Upload a cover image in Details.': "Carica un'immagine di copertina nei Dettagli.",
    "Write the image's alt text (Google and people who can't see read it).": "Scrivi il testo alternativo dell'immagine (lo leggono Google e chi non vede).",
    'With alt text.': 'Con testo alternativo.',
    'Write what you will talk about in the live stream.': 'Scrivi di cosa parlerai nella diretta.',
    'Add a few more lines.': 'Aggiungi qualche riga in più.',
    'Upload a thumbnail in Details: it shows in the live stream announcement.': "Carica una miniatura nei Dettagli: si vede nell'annuncio della diretta.",
    'Start time': 'Orario',
    'On {date} at {time}.': 'Il {date} alle {time}.',
    'Set the day and time in Details (Dates › Live stream start): you need them to announce it.': 'Metti giorno e ora nei Dettagli (Date › Inizio della diretta): servono per annunciarla.',
    // features/seo.ts and SeoPanel.vue: tabs, badge, panels
    'Publishing': 'Pubblicazione',
    'Web SEO': 'SEO web',
    '{label}: {n} checks out of {max}': '{label}: {n} controlli su {max}',
    'Details': 'Dettagli',
    'Released': 'Pubblicato',
    'Copy': 'Copia',
    'Find ideas': 'Cerca idee',
    'HASHTAGS': 'HASHTAG',
    '(optional)': '(facoltativi)',
    'They count for little today: if you use them, 2–3 relevant ones are enough. They are not part of the score.': 'Oggi contano poco: se li usi, 2–3 pertinenti bastano. Non entrano nel punteggio.',
    'Shown before "more":': 'Prima di "altro" si vede:',
    "Add the project's fixed text at the end": 'Aggiungi in fondo il testo fisso del progetto',
    'HOOK AND DURATION': 'GANCIO E DURATA',
    'Open the script': 'Apri lo script',
    'KEYWORD': 'PAROLA CHIAVE',
    'E.g. super mario 64 secrets': 'Es. super mario 64 segreti',
    'TITLE': 'TITOLO',
    'Title of the Short': 'Titolo dello Short',
    'CAPTION': 'DIDASCALIA',
    'One caption for YouTube Shorts, TikTok and Instagram. Put the keyword in the first line.': 'Una sola didascalia per YouTube Shorts, TikTok e Instagram. Metti la parola chiave nella prima riga.',
    'PREVIEW': 'ANTEPRIMA',
    'Copy title and caption': 'Copia titolo e didascalia',
    'LIVE STREAM TITLE': 'TITOLO DELLA DIRETTA',
    'Live stream title': 'Titolo della diretta',
    'DESCRIPTION': 'DESCRIZIONE',
    'Copy the full description': 'Copia la descrizione completa',
    'What you will talk about, at what time, what viewers should get ready...': 'Di cosa parlerai, a che ora, cosa deve preparare chi guarda...',
    'Copy title and description': 'Copia titolo e descrizione',
    'The first line is the hook: short, with the keyword. Then the rest of the text.': 'La prima riga è il gancio: corta, con la parola chiave. Poi il resto del testo.',
    'Copy the caption': 'Copia la didascalia',
    'E.g. how to start a youtube channel': 'Es. come iniziare un canale youtube',
    'TITLE FOR GOOGLE': 'TITOLO PER GOOGLE',
    'Article title': "Titolo dell'articolo",
    'META DESCRIPTION': 'META DESCRIZIONE',
    'Two lines that make people click, with the keyword.': 'Due righe che convincono a cliccare, con la parola chiave.',
    'PAGE ADDRESS': 'INDIRIZZO DELLA PAGINA',
    'Generate from the title': 'Genera dal titolo',
    'how-to-start-a-youtube-channel': 'come-iniziare-un-canale-youtube',
    'COVER ALT TEXT': 'TESTO ALTERNATIVO DELLA COPERTINA',
    'What the image shows, in a few words': "Cosa si vede nell'immagine, in poche parole",
    'GOOGLE PREVIEW': 'ANTEPRIMA SU GOOGLE',
    'Copy title, description and address': 'Copia titolo, descrizione e indirizzo',
    'MAIN KEYWORD': 'PAROLA CHIAVE PRINCIPALE',
    'Secondary keywords, separated by commas (2–3)': 'Parole chiave secondarie, separate da virgole (2–3)',
    'YOUTUBE TITLE': 'TITOLO SU YOUTUBE',
    'Video title': 'Titolo del video',
    'Title variant': 'Variante del titolo',
    'Use this as the title': 'Usa questa come titolo',
    'Use': 'Usa',
    'Title variant (to compare them or for YouTube tests)': 'Variante del titolo (per confrontarle o per i test di YouTube)',
    'The first lines matter most: they show in search. Put the keyword at the start.': "Le prime righe sono le più importanti: si vedono nella ricerca. Metti la parola chiave all'inizio.",
    'Shown in search:': 'Si vede nella ricerca:',
    'Socials, useful links, gear, an invitation to subscribe... You write it once and it applies to every video of the project.': 'Social, link utili, attrezzatura, invito a iscriversi... Lo scrivi una volta e vale per tutti i video del progetto.',
    'CHAPTERS': 'CAPITOLI',
    '0:00 Intro&#10;1:24 The castle&#10;3:10 The secrets': '0:00 Intro&#10;1:24 Il castello&#10;3:10 I segreti',
    "Generate from the script's headings": 'Genera dai titoli dello script',
    'times estimated from reading: adjust them after editing.': 'orari stimati dalla lettura: ritoccali dopo il montaggio.',
    'TAGS': 'TAG',
    'Separated by commas: super mario 64, mario 64 secrets, nintendo 64': 'Separati da virgole: super mario 64, mario 64 segreti, nintendo 64',
    'Suggest from the keywords and the title': 'Suggerisci dalle parole chiave e dal titolo',
    'YOUTUBE PREVIEW': 'ANTEPRIMA SU YOUTUBE',
    'Copy everything for YouTube Studio': 'Copia tutto per YouTube Studio',
    '{n} character': '{n} caratteri',
    '{n} characters': '{n} caratteri',
    'empty': 'vuota',
    'Ready for YouTube!': 'Pronto per YouTube!',
    'Ready for YouTube?': 'Pronto per YouTube?',
    'Ready to publish!': 'Pronto da pubblicare!',
    'Ready to publish?': 'Pronto da pubblicare?',
    'Post ready!': 'Post pronto!',
    'Post ready?': 'Post pronto?',
    'Live stream ready!': 'Diretta pronta!',
    'Live stream ready?': 'Diretta pronta?',
    'Ready for Google!': 'Pronto per Google!',
    'Ready for Google?': 'Pronto per Google?',
    'yoursite.com': 'iltuosito.it',
    'article': 'articolo',
    'The meta description appears here, under the title.': 'La meta descrizione compare qui, sotto il titolo.',
    'Your profile': 'Il tuo profilo',
    'Caption…': 'Didascalia…',
    'more': 'altro',
    'FIRST SENTENCE OF THE SCRIPT': 'PRIMA FRASE DELLO SCRIPT',
    'Estimated duration: about {time} ({n} words)': 'Durata stimata: circa {time} ({n} parole)',
    "This video doesn't have a script yet: create it in Details (Script and notes). The first sentence becomes the hook, and from there I estimate the duration.": 'Questo video non ha ancora uno script: crealo nei Dettagli (Script e appunti). La prima frase diventa il gancio e da lì stimo la durata.',
    'Your channel': 'Il tuo canale',
    'SEARCH · COMPUTER': 'RICERCA · COMPUTER',
    'Description…': 'Descrizione…',
    'HOME · PHONE': 'HOME · TELEFONO',
    "This video doesn't have a built-in script yet: create it in the Details tab, with headings for the parts of the video.": 'Questo video non ha ancora uno script integrato: crealo nella scheda Dettagli, con dei titoli per le parti del video.',
    'The script has no headings (Heading 1–4): add some to split the video into parts, or write the chapters by hand.': 'Nello script non ci sono titoli (Titolo 1–4): aggiungili per dividere il video in parti, oppure scrivi i capitoli a mano.',
    'Intro': 'Intro',
    'ADDRESS': 'INDIRIZZO',
    'ALT TEXT': 'TESTO ALTERNATIVO',
    'Copied! Paste it on Shorts, TikTok or Instagram.': 'Copiato! Incollalo su Shorts, TikTok o Instagram.',
    'Copied! Paste it into the post.': 'Copiato! Incollalo nel post.',
    'Copied! Paste it into your site.': 'Copiato! Incollalo nel tuo sito.',
    'Copied!': 'Copiato!',
    'Copied! Paste it into YouTube Studio.': 'Copiato! Incollalo in YouTube Studio.',
    'Give the video a title first (Details tab): that way I can save it before opening Trends.': 'Dai prima un titolo al video (scheda Dettagli): così lo salvo prima di aprire le Tendenze.',
    // PublishedPanel.vue, PublishedBox.vue, markPublished
    'Other link': 'Altro link',
    "This doesn't look like a link (it must be a web address).": 'Questo non sembra un link (deve essere un indirizzo web).',
    'Added to <b>{name}</b>.': 'Messo in <b>{name}</b>.',
    '<b class="text-gray-100">Published video details.</b> The links you add here become buttons on its card in the Published videos page.': '<b class="text-gray-100">Informazioni del video pubblicato.</b> I link che metti qui diventano pulsanti sulla sua card nella pagina Video pubblicati.',
    '<b class="text-gray-100">The video is ready.</b> When it comes out, add here where you uploaded it, then press <b>Mark as published</b> in the Details tab.': '<b class="text-gray-100">Il video è pronto.</b> Quando esce, aggiungi qui dove l\'hai caricato e poi premi <b>Segna come pubblicato</b> nella scheda Dettagli.',
    'RELEASED ON': 'USCITO IL',
    'PASTE A LINK': 'INCOLLA UN LINK',
    "Paste the link: I'll put it in the right social by myself": 'Incolla il link: lo metto da solo nel social giusto',
    'Add': 'Aggiungi',
    'WHERE IT WAS UPLOADED': 'DOVE È STATO CARICATO',
    'Open': 'Apri',
    'PUBLISHING NOTES': 'NOTE SULLA PUBBLICAZIONE',
    'E.g. also uploaded as a Short, collaboration with…, sponsor…': 'Es. caricato anche come Short, collaborazione con…, sponsor…',
    'Changes are saved with <b>Save video</b>.': 'Le modifiche si salvano con <b>Salva video</b>.',
    'Add the social links': 'Aggiungi i link dei social',
    'Open on {name}': 'Apri su {name}',
    'This video is in <b>Published videos</b>: it does not appear on the Board.': 'Questo video è nei <b>Video pubblicati</b>: non compare nella Board.',
    'Back to the plan': 'Rimetti nel PED',
    'The video leaves the Board and goes to the "Published videos" page. You can put it back in the plan whenever you like.': 'Il video esce dalla Board e va nella pagina "Video pubblicati". Lo puoi rimettere nel PED quando vuoi.',
    'Search published videos': 'Cerca nei video pubblicati',
    'Videos that are already out end up here': 'Qui finiscono i video già usciti',
    '{n} published video': '{n} video pubblicato',
    '{n} published videos': '{n} video pubblicati',
    '{count} · {n} this month': '{count} · {n} questo mese',
    'No videos found.': 'Nessun video trovato.',
    'No published videos yet.<br>When a video is out, press <b>Mark as published</b> on its card in the "Ready/Published" column of the Board, or in its window: it leaves the Board and you find it here.': 'Nessun video pubblicato ancora.<br>Quando un video è uscito, premi <b>Segna come pubblicato</b> sulla sua card nella colonna "Pronto/Pubblicato" della Board, oppure nella sua finestra: lascia la Board e lo ritrovi qui.',
    'No date': 'Senza data',
    'Release date not set': 'Data di uscita non indicata',
    'Released on {date} at {time}': 'Uscito il {date} alle {time}',
    'Released on {date}': 'Uscito il {date}',
    'Year': 'Anno',
    // features/shorts.ts, ShortButton.vue, ShortsDialog.vue
    'Starts with a question': 'Inizia con una domanda',
    'Strong opening': 'Inizio forte',
    'Starts with a number': 'Inizia con un numero',
    'Stands on its own': 'Si capisce da solo',
    'A whole section': 'È una sezione intera',
    'Punchy ending': 'Chiusura secca',
    'Ideal length': 'Durata ideale',
    'To use this feature the video must be horizontal (Long Form)': 'Per utilizzare questa funzione il video deve essere orizzontale (Long Form)',
    'Create the video script first: the Shorts are taken from it': 'Prima crea lo script del video: gli Short si ricavano da lì',
    'The script is too short: you need at least {min} words (now {n})': 'Lo script è troppo corto: servono almeno {min} parole (ora {n})',
    'Create Shorts from the script': 'Crea Short dallo script',
    '~{sec} s · {n} words': '~{sec} s · {n} parole',
    'Read the text': 'Leggi il testo',
    'Created in the plan, "Scripting" column, with its own script': 'Creato nel PED, colonna "In Script", con il suo script',
    'Create this Short': 'Crea questo Short',
    'Possible Shorts': 'Short possibili',
    'Script pieces of 20–60 seconds that stand on their own': 'Pezzi dello script da 20–60 secondi che reggono da soli',
    'I couldn\'t find suitable pieces: you need at least {min} words in a row, split into sentences with full stops, that make sense on their own (no "as I was saying", "so"… at the start). The more the script is split into headings and paragraphs, the better the suggestions.': 'Non ho trovato pezzi adatti: servono almeno {min} parole di fila, divise in frasi con il punto, che si capiscano anche da sole (senza "come dicevo prima", "quindi"… all\'inizio). Più lo script è diviso in titoli e paragrafi, migliori sono le proposte.',
    "The suggestions come from the shape of the text (opening, ending, length), not from its meaning: reread them and fix them in the Short's script.": 'Le proposte sono calcolate dalla forma del testo (inizio, chiusura, lunghezza), non dal significato: rileggile e sistemale nello script dello Short.',
    'long video': 'video lungo',
    'Body': 'Corpo',
    'Ending': 'Finale',
    'The full video is on the channel.': 'Il video completo è sul canale.',
    'Short taken from {ref}': 'Short ricavato da {ref}',
    'Short taken from "{title}"': 'Short ricavato da "{title}"',
    'First draft': 'Prima bozza',
    'Short added to the plan': 'Short aggiunto al PED',
    // src/components/video/MetricsPanel.vue, VideoTabs.vue, src/components/VerdictButton.vue, src/features/metrics.ts
    'Metrics': 'Metriche',
    'Bad': 'Male',
    'Average': 'Nella media',
    'Good': 'Bene',
    'Views': 'Visualizzazioni',
    'Likes': 'Mi piace',
    'Comments': 'Commenti',
    'Shares': 'Condivisioni',
    'Saves': 'Salvataggi',
    'New followers': 'Nuovi follower',
    'Retention (%)': 'Fidelizzazione (%)',
    'Average watch time': 'Durata media visione',
    'How is it doing?': 'Come sta andando?',
    'How is it going?': 'Come va?',
    'How is it going on {name}?': 'Come sta andando su {name}?',
    'For each platform, choose Bad, Average or Good and, if you like, copy the numbers from its statistics. They stay only in Hideo.': 'Per ogni piattaforma scegli Male, Nella media o Bene e, se vuoi, copia i numeri dalle sue statistiche. Restano solo in Hideo.',
    'Updated {date}': 'Aggiornate il {date}',
    'Notes: what worked, what to change next time…': 'Appunti: cosa ha funzionato, cosa cambiare la prossima volta…',
    'No platform yet: add the links in the Released tab, or choose one here.': 'Ancora nessuna piattaforma: aggiungi i link nella scheda Pubblicato, oppure scegline una qui.',
    'Add a platform…': 'Aggiungi una piattaforma…',
    'Numbers…': 'Numeri…',
    'e.g. 2:15': 'es. 2:15',
}

export default it
